import { render, staticRenderFns } from "./saturnalia-info.vue?vue&type=template&id=4e88dca7&scoped=true"
import script from "./saturnalia-info.vue?vue&type=script&lang=js"
export * from "./saturnalia-info.vue?vue&type=script&lang=js"
import style0 from "./saturnalia-info.vue?vue&type=style&index=0&id=4e88dca7&prod&scoped=true&lang=css"
import style1 from "./saturnalia-info.vue?vue&type=style&index=1&id=4e88dca7&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e88dca7",
  null
  
)

export default component.exports